import { SubmissionState } from '../enums/submission-state.enum';
import { SubmissionReview } from './submission-review.model';

export class WorkflowSubmissionReview implements SubmissionReview {
    state: SubmissionState;
    commentToProducer: string;

    set CommentToProducer(val: string) {
        this.commentToProducer = val;
    }
    get CommentToProducer(): string {
        return this.commentToProducer;
    }
}
